import React from "react";
import { EntireCategoryBackground, SemiCategory1, SemiCategory2, CategoryLink } from "./Categories.styles";
import studyImage from "assets/MainImage/studyImage.png";
import seminarImage from "assets/MainImage/seminarImage.png";
import sportsImage from "assets/MainImage/sportsImage.png";
import cultureImage from "assets/MainImage/cultureImage.png";
import printImage from "assets/MainImage/printImage.png";

function Categories() {
  const categories = [
    { path: "/study", icon: studyImage, label: "스터디" },
    { path: "/semina", icon: seminarImage, label: "세미나" },
    { path: "/sportfacilities", icon: sportsImage, label: "체육시설" },
    { path: "/culturespace", icon: cultureImage, label: "문화공간" },
    { path: "/printerpc", icon: printImage, label: "프린터/PC" },
  ];

  return (
    <EntireCategoryBackground>
      {categories.map((category, index) => {
        const CategoryComponent = index === categories.length - 1 ? SemiCategory2 : SemiCategory1;
        return (
          <CategoryLink key={category.path} to={category.path} target="_self">
            <CategoryComponent>
              <div className="icon">
                <img src={category.icon} alt={category.label} />
              </div>
              <p>{category.label}</p>
            </CategoryComponent>
          </CategoryLink>
        );
      })}
    </EntireCategoryBackground>
  );
}

export default Categories;
